import { Icon, Props, getRotation } from "./ArrowIcon.Parts";

export const ArrowIcon = ({
  orientation = "left",
  style,
  ref,
  ...props
}: Props) => {
  const { rotation } = getRotation(orientation);

  return (
    <Icon
      viewBox="0 0 12 11"
      fill="none"
      width="12"
      height="10.286"
      xmlns="http://www.w3.org/2000/svg"
      $rotation={rotation}
      ref={ref}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5.14286C12 4.66947 11.6162 4.28571 11.1429 4.28571L0.857143 4.28571C0.383756 4.28571 -4.08218e-07 4.66947 -4.49603e-07 5.14286C-4.90988e-07 5.61624 0.383756 6 0.857143 6L11.1429 6C11.6162 6 12 5.61624 12 5.14286Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.74895 0.251051C5.41421 -0.0836844 4.8715 -0.0836844 4.53677 0.251051L0.251051 4.53676C-0.0836844 4.8715 -0.0836844 5.41421 0.25105 5.74895L4.53676 10.0347C4.8715 10.3694 5.41421 10.3694 5.74895 10.0347C6.08368 9.69993 6.08368 9.15721 5.74895 8.82248L2.06933 5.14286L5.74895 1.46323C6.08368 1.1285 6.08368 0.585786 5.74895 0.251051Z"
        fill="currentColor"
      />
    </Icon>
  );
};
